// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import { withRouter } from '../../../../router-compat';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';

import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Tooltip from '../../../ui/Tooltip';
import { HelpIcon } from '../../../ui/icons';
import { apexBase, movPalette } from '../../../ui/chartTheme';

const chartColors = {
  completed: movPalette[0],
  abandonEmail: '#ea3546',
  abandonNoEmail: '#f86624',
  direct: '#43bccd',
  influenced: '#f86624',
};

class Chart extends Component {
  barOptions() {
    const { chartData } = this.props.store.analytics;
    return apexBase({
      chart: { type: 'bar', stacked: true },
      plotOptions: {
        bar: { columnWidth: '55%', borderRadius: 4, borderRadiusApplication: 'end', borderRadiusWhenStacked: 'last' },
      },
      xaxis: {
        categories: chartData.map(([dateStart]) => moment(dateStart).add(1, 'day').format('MMM DD')),
      },
      colors: [chartColors.completed, chartColors.abandonEmail, chartColors.abandonNoEmail],
      legend: { position: 'top', horizontalAlign: 'left' },
    });
  }

  barSeries() {
    const { chartData } = this.props.store.analytics;
    return [
      {
        name: 'Forms Completed',
        data: chartData.map(([, d]) => Number(d.forms_started) - Number(d.abandons)),
      },
      {
        name: 'Abandons with Email',
        data: chartData.map(([, d]) => Number(d.unique_valid_abandoned_emails)),
      },
      {
        name: 'Abandons without Email',
        data: chartData.map(([, d]) => Number(d.abandons) - Number(d.unique_valid_abandoned_emails)),
      },
    ];
  }

  donutOptions(hasData) {
    return apexBase({
      chart: { type: 'donut' },
      labels: hasData ? ['Direct Saves', 'Influenced Saves'] : ['No data'],
      colors: hasData ? [chartColors.direct, chartColors.influenced] : ['#efece2'],
      legend: { show: false },
      stroke: { width: 0 },
      plotOptions: {
        pie: {
          donut: {
            size: '72%',
            labels: { show: false },
          },
          expandOnClick: false,
        },
      },
      tooltip: { enabled: hasData },
      states: hasData ? undefined : {
        hover: { filter: { type: 'none' } },
        active: { filter: { type: 'none' } },
      },
    });
  }

  donutSeries() {
    const { totalSaves, totalDirectRecaptures, totalInfluencedSaved } = this.props.store.analytics;
    return totalSaves ? [totalDirectRecaptures, totalInfluencedSaved] : [100];
  }

  render() {
    const paidPlan = typeof this.props.store.auth.paidPlan === 'function' ? this.props.store.auth.paidPlan() : this.props.store.auth.paidPlan;
    const { totalSaves, statSum } = this.props.store.analytics;
    const emailsDelivered = statSum('emails_delivered');

    return (
      <section className="grid gap-5 mb-5 grid-cols-1 lg:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]">
        <Card>
          <CardHead title="Form metrics" sub="Started, completed, and abandoned over time" />
          <ReactApexChart
            type="bar"
            height={280}
            options={this.barOptions()}
            series={this.barSeries()}
          />
        </Card>

        <Card>
          <div className="flex items-start justify-between gap-2 mb-3.5">
            <div>
              <h3 className="m-0 text-[14.5px] font-semibold">Recapture metrics</h3>
              <div className="text-[12px] text-mov-ink-mute">Direct + influenced saves</div>
            </div>
            <Tooltip
              content="Direct saves come from a remarket email link. Influenced saves are from sessions after opening the email."
              side="left"
            >
              <span className="text-mov-ink-mute"><HelpIcon size={14} /></span>
            </Tooltip>
          </div>

          <div style={{ position: 'relative', height: 220 }}>
            <ReactApexChart
              type="donut"
              height={220}
              options={this.donutOptions(!!totalSaves)}
              series={this.donutSeries()}
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <span className="mov-display text-[28px] leading-none">{totalSaves.toLocaleString()}</span>
              <span className="mov-mono text-[10.5px] uppercase tracking-wider text-mov-ink-mute mt-1">Total saves</span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 mt-4 pt-4" style={{ borderTop: '1px solid var(--mov-line)' }}>
            <div>
              <div className="mov-mono text-[10.5px] uppercase tracking-wider text-mov-ink-mute">Emails sent</div>
              <div className="mov-display text-[20px] leading-none mt-1">{emailsDelivered.toLocaleString()}</div>
            </div>
            <div>
              <div className="mov-mono text-[10.5px] uppercase tracking-wider text-mov-ink-mute">Saves</div>
              <div className="mov-display text-[20px] leading-none mt-1">{totalSaves.toLocaleString()}</div>
            </div>
          </div>

          {!paidPlan && (
            <div className="absolute inset-0 grid place-items-center"
              style={{ background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(2px)' }}
            >
              <Button variant="primary" onClick={() => this.props.history.push('/faq')}>
                Premium feature
              </Button>
            </div>
          )}
        </Card>
      </section>
    );
  }
}

export default withRouter(inject('store')(observer(Chart)));
